import { request } from "../request";

// 获取待确认的绑定申请
export const getBindRequests = () =>
  request("/v1/student/bindRequests", "get");

// 确认/拒绝绑定
export const confirmBind = (data) =>
  request("/v1/student/bindConfirm", "post", { json: data });

// 获取待确认绑定请求数量
export const getPendingBindCount = () =>
  request("/v1/student/bindRequestCount", "get");

// 获取已绑定的家长列表
export const getBoundParents = () =>
  request("/v1/student/parents", "get");

// 解绑家长
export const unbindParent = (id) =>
  request(`/v1/student/unbindParent/${id}`, "delete");
